var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVpnKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1503",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8018 17.0098L14.1094 17.6895L12.8936 16.4961V17C12.8936 18.1206 13.2952 19.0727 14.0986 19.8564C14.9023 20.6401 15.8809 21.0322 17.0332 21.0322C17.3052 21.0322 17.5772 21.0036 17.8486 20.9453C18.1201 20.887 18.3851 20.7991 18.6436 20.6826L19.3828 21.4082C19.0131 21.6033 18.631 21.7509 18.2373 21.8506C17.8436 21.9502 17.4423 22 17.0332 22C15.6121 22 14.402 21.514 13.4043 20.543C12.4067 19.572 11.9082 18.391 11.9082 17V16.4961L10.6924 17.6895L10 17.0098L12.4004 14.6523L14.8018 17.0098Z",
    fill: "#ABB2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9668 12C18.3879 12 19.598 12.486 20.5957 13.457C21.5933 14.428 22.0918 15.609 22.0918 17V17.5039L23.3076 16.3105L24 16.9902L21.5996 19.3477L19.1982 16.9902L19.8906 16.3105L21.1064 17.5039V17C21.1064 15.8794 20.7048 14.9273 19.9014 14.1436C19.0977 13.3599 18.1191 12.9678 16.9668 12.9678C16.6948 12.9678 16.4228 12.9964 16.1514 13.0547C15.8799 13.113 15.6149 13.2009 15.3564 13.3174L14.6172 12.5918C14.9869 12.3967 15.369 12.2491 15.7627 12.1494C16.1564 12.0498 16.5577 12 16.9668 12Z",
    fill: "#ABB2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3C5.97182 3 6.88384 3.27521 7.73633 3.8252C8.58899 4.3752 9.20563 5.1 9.58496 6H20V10H18V11.1494C17.6739 11.0832 17.3399 11.0409 17 11.0186V9H19V7H8.84961C8.71628 6.35012 8.31686 5.68757 7.65039 5.0127C6.98372 4.3377 6.1 4 5 4C3.9 4 2.95814 4.39147 2.1748 5.1748C1.39147 5.95814 1 6.9 1 8C1 9.1 1.39147 10.0419 2.1748 10.8252C2.95814 11.6085 3.9 12 5 12C6.1 12 6.98372 11.6623 7.65039 10.9873C8.31686 10.3124 8.71628 9.64988 8.84961 9H15V11.1494C14.6575 11.2189 14.3238 11.3133 14 11.4277V10H9.58496C9.20563 10.9 8.58899 11.6248 7.73633 12.1748C6.88384 12.7248 5.97182 13 5 13C3.61117 13 2.43034 12.5143 1.45801 11.543C0.486022 10.5718 8.94058e-05 9.39232 0 8.00488C0 6.61737 0.48606 5.43618 1.45801 4.46191C2.43034 3.48758 3.61117 3 5 3Z",
    fill: "#ABB2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.76953C5.3385 6.76953 5.62814 6.88986 5.86914 7.13086C6.11014 7.37186 6.23047 7.6615 6.23047 8C6.23047 8.3385 6.11014 8.62814 5.86914 8.86914C5.62814 9.11014 5.3385 9.23047 5 9.23047C4.6615 9.23047 4.37186 9.11014 4.13086 8.86914C3.88986 8.62814 3.76953 8.3385 3.76953 8C3.76953 7.6615 3.88986 7.37186 4.13086 7.13086C4.37186 6.88986 4.6615 6.76953 5 6.76953Z",
    fill: "#ABB2CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpnKey);
export default __webpack_public_path__ + "static/media/vpn_key.c5b5899262c857b8a66810b01a335f8d.svg";
export { ForwardRef as ReactComponent };